// extracted by mini-css-extract-plugin
export default {"onesync":"tNgg9+07"};